interface TopBarProps {
  count: number;
}

export function TopBar({ count }: TopBarProps) {
  return (
    <div className="topbar">
      <div className="container topbar-inner">
        <div className="topbar-left">
          <span>Vol. 01, No. 01</span>
          <span>Established 2026</span>
          <span>For Small Business</span>
        </div>
        <div className="topbar-right">
          <span className="ticker">Live - {count.toLocaleString()} on waitlist</span>
          <a href="#how">How it works</a>
          <a href="#waitlist">Get early access</a>
        </div>
      </div>
    </div>
  );
}
